export default __webpack_public_path__ + "static/media/Keypad_white.d7e83fc6.svg";